import { render, staticRenderFns } from "./ShopifyNotifications.vue?vue&type=template&id=972b832a&"
import script from "./ShopifyNotifications.vue?vue&type=script&lang=js&"
export * from "./ShopifyNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports